module.exports = __webpack_public_path__ + "9a79487d241c84bebeb2495e6dc49cf0.pdf";